// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './pc_mall_intact.vue'
import 'babel-polyfill'
import router from './router'
import store from './store/store'
import api from './apis/api'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import ElementUI from 'element-ui'
// import './assets/css/theme-chalk/index.css'
import './assets/css/common.css'
// require styles
import 'swiper/dist/css/swiper.css'
import dialog from './components/common/dialog/dialog.vue'
import VueLazyload from 'vue-lazyload'
import { getCookie } from '../../util/util'
import { clearCookie } from '../../util/celecookie'
import clickoutside from './assets/js/directive'
import verify from 'vue-verify-plugin'
import BaiduMap from 'vue-baidu-map'
import {ElementControl} from '../../util/ElementControl'; // 元素控制配置信息
Vue.prototype.ElementControl=ElementControl;
import {returnDateWeek} from '../../util/returnDateWeek'; // 返回星期几
Vue.prototype.returnDateWeek=returnDateWeek;

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'e4nogcRyySCUDSk9z4jz4xvh'
})
Vue.use(verify, {
  blur: true
})

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/noGoods.png',
  loading: '/static/noGoods.png',
  attempt: 1
})

Vue.use(VueAwesomeSwiper)
// Vue.use(ElementUI)
Vue.use(clickoutside)

Vue.component('myDialog', dialog)

Vue.config.productionTip = false
/**
 * 路由跳转
 * @param next 路由
 */
// function nextRoute (next) {
//   // 线上
//  //  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
//   // next({path: v.templatepresall})
//   // 线下
//   next()
// }

/**
 * 路由过滤
 */
router.beforeEach((to, from, next) => {
  // let  test = window.location.href
  // let number = test.indexOf("r.do")
  // if(number>0){
  //   let hosts =  location.host
  //   let  indexs = hosts.indexOf(".")
  //   let https = hosts.substring(0,indexs)
  //    let  tests = window.location.href
  //    let number = tests.indexOf("r.do")
  //    let url = tests.substring(number)
  //    window.location.href = `${store.state.common.https}${https}.maboy.cn/${url}`
  //    console.log(`${store.state.common.https}${https}.maboy.cn/${url}`) 
  //    return
  // }
  //   let host =  location.host
	// //线上
  //   let urls = '.cutmall.cn' 
  //      if(!host.includes(urls)){
  //          let  index = host.indexOf(".")
  //          let http = host.substring(0,index)
  //         window.location.href = `${store.state.common.https}${http}${urls}`
  //       }
  // if (to.name == '错误页404') {
  //   next()
  // }
  window.scrollTo(0, 0)
  // 线上
     let loc = location.host
  // 线下
 // let loc = 'jht.th28.cn'
  if (getCookie('allreqdomain') === '' || getCookie('allreqdomain') === 'undefined' || !getCookie('allreqdomain')) { // 尚未初始化
    initComyinfo(loc, next);
  } else { // 已初始化完成
    let allreqdomain = JSON.parse(getCookie('allreqdomain'))
    // store.state.logoimgurl = JSON.parse(getCookie('logoimgurl'))
    // store.state.allreqdomain = JSON.parse(getCookie('allreqdomain'))
    let maindomain = allreqdomain.maindomain.pc // pc商城主体域名
    let preselldomain = allreqdomain.preselldomain.pc // pc预售板块域名
    let tracedomain = allreqdomain.tracedomain.pc // pc溯源板块域名
    let websitedomain = allreqdomain.websitedomain.pc // pc企业官网域名
    let alldomain = `${maindomain},${preselldomain},${tracedomain},${websitedomain}`
    if (alldomain.includes(loc)) { // 判断域名是否包含在企业信息里
      /**
       * @描述 调用禁止配送区域说明
       */
      if((!localStorage.getItem("nodeliveryDisrange") || localStorage.getItem("nodeliveryDisrange")==undefined)&&sessionStorage.getItem("noOpenDisrange")!='1') {
        api.GET_NODELIVERYDISRANGE({}).then(res => {
          if (res.data.status == '001') {
            localStorage.setItem('nodeliveryDisrange', res.data.data.memo);
          }
          if (res.data.status == '003') {
            sessionStorage.setItem('noOpenDisrange', '1');
          }
        })
      }
      againComyinfo(next)
    } else { // 不包含时重新初始化公司信息
      clearCookie()
      initComyinfo(loc, next);
    }
  }
})

/**
 * 初始化公司信息
 * @param loc 域名
 * @param next 路由
 */
async function initComyinfo (loc, next) {
  let reqDomainparams = {
    reqdomain: loc,
    terminaltype: 0
  }
  let statusValue = '';
  await store.dispatch('CmpyinfoByReqdomain', reqDomainparams).then(res => {
    statusValue = res.data.status;
    if (res.data.status == '001') {
      store.state.logoimgurl = JSON.parse(getCookie('logoimgurl'))
      store.state.allreqdomain = getCookie('allreqdomain')
      /**
       * @描述 调用禁止配送区域说明
       */
      api.GET_NODELIVERYDISRANGE({}).then(res => {
        if (res.data.status == '001') {
          localStorage.setItem('nodeliveryDisrange', res.data.data.memo);
        }
        if (res.data.status == '003') {
          sessionStorage.setItem('noOpenDisrange', '1');
        }
      })
    }
  }).catch(function() {
    if(sessionStorage.getItem('statusValue')) {
        sessionStorage.setItem('statusValue','');
        next();
    } else {
        sessionStorage.setItem('statusValue','400');
        next('/500');
    }
  })
  if(!statusValue) {
      return false;
  }
  if(statusValue == "400") {
      if(sessionStorage.getItem('statusValue')) {
          sessionStorage.setItem('statusValue','');
          next();
      } else {
          sessionStorage.setItem('statusValue','400');
          next('/500');
      }
      return false;
  }
  await store.dispatch('getSysmarinfo')
  await store.dispatch('getPubordprintinfo')
  await store.dispatch('getPubconfiginfo')
  await store.dispatch('getSysconelementsinfo')
  await next()
}

/**
* 基础信息没有缓存时，调取方法
* @param next 路由
*/
async function againComyinfo(next) {
  // if(getCookie('getSysmarinfo') === '' || getCookie('getSysmarinfo') === 'undefined') {
  //     await store.dispatch('getSysmarinfo')
  // }
  // if(sessionStorage.getItem("getPubconfiginfo") === '' || sessionStorage.getItem("getPubconfiginfo") === 'undefined' || sessionStorage.getItem("getPubconfiginfo") === null) {
  //     await store.dispatch('getPubconfiginfo')
  // }
  // if(sessionStorage.getItem("getPubordprintinfo") === '' || sessionStorage.getItem("getPubordprintinfo") === 'undefined' || sessionStorage.getItem("getPubordprintinfo") === null) {
  //     await store.dispatch('getPubordprintinfo')
  // }
  if(sessionStorage.getItem("elementsInfo") === '' || sessionStorage.getItem("elementsInfo") == undefined || sessionStorage.getItem("elementsInfo") === null) {
      await store.dispatch('getSysconelementsinfo')
  }
  await next()
}

/* eslint-disable no-new */
new Vue({
  el: '#pc_mall_intact',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/pc_mall_intact.js